import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SyncIcon from "@mui/icons-material/Sync";

interface InventoryListSyncButtonProps {
  isSyncing: boolean;
  onSync: () => void;
}

/** The inventory page's "Sync now": pulls Cin7's and eStore's levels again. */
export const InventoryListSyncButton = (props: InventoryListSyncButtonProps) => {
  const { isSyncing, onSync } = props;
  let icon = <SyncIcon fontSize="small" />;
  let label = "Sync now";
  if (isSyncing) {
    icon = (
      <CircularProgress
        color="inherit"
        size={14}
        thickness={6}
      />
    );
    label = "Syncing…";
  }

  return (
    <Button
      disabled={isSyncing}
      onClick={onSync}
      size="small"
      startIcon={icon}
      variant="outlined"
    >
      {label}
    </Button>
  );
};
